import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import {
    Tc,
    WBotanicaExtendedItemResultsViewModel,
    TwTcEppoItemResultsViewModel,
    TcPaisUsaCodigoPostal,
    WOrganismosNocivosExtendedItemResultsViewModel,
    TwTcTipoOrganismoNocivoViewModel,
    WUnlocodeItemResultsViewModel,
    MotivoMedidaViewModel,
    TcExpanded,
} from '../../types/common';
import { FormaViewModel } from '../../../../_mantenimiento/especies/gruposformas/grupoforma.types';
import { MunicipioViewModel } from '../../../../_mantenimiento/general/municipios/municipios.types';
import { TCampaniaEspecificaViewModel } from '../../../../_mantenimiento/campanias/campaniasespecificas/campaniaespecifica.types';
import { PeriodoCamViewModel } from '../../../../_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
import { SubTipoSolicitudExViewModel } from '../../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';

// https://angular.io/tutorial/toh-pt6
// https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class GlobalService {
    private tipoSolicitudCam: Tc[] = [];
    private comunidadesAutonomas: Tc[] = [];
    private provincias: Tc[] = [];
    private perfilesUsuario: Tc[] = [];
    private tiposInspeccionCam: Tc[] = [];

    constructor(
        private http: HttpClient,

        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getAllCampanias(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/campanias').pipe();
    }

    getCampaniasPeriodosActivos(): Observable<TCampaniaEspecificaViewModel[]> {
        return this.http.get<TCampaniaEspecificaViewModel[]>(this.baseUrl + 'api/core/global/campaniasPeriodosActivos').pipe();
    }

    getPeriodosActivosByIdCampania(id: number): Observable<PeriodoCamViewModel[]> {
        return this.http.get<PeriodoCamViewModel[]>(this.baseUrl + 'api/core/global/periodosActivosByIdCampania/' + id).pipe();
    }

    getAllPaises(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises').pipe();
    }

    getAllPaisesExpor(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paisesExpor').pipe();
    }

    getAllPaisesSinSpain(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/allsinspain').pipe();
    }

    getPaisesUe(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/ue').pipe();
    }

    getAllPaisesNoUe(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/noue').pipe();
    }

    getAllPaisesNoUeConSpain(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/noueconspain').pipe();
    }

    getPaisesUeSinSpain(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/uesinspain').pipe();
    }

    getGrupoPaisesFr(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/paises/grupopaisesfr').pipe();
    }

    getInstalacionesAutorizadas(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/instalacionesAutorizadas').pipe();
    }

    getAllInstalacionesAutorizadas(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/allinstalacionesAutorizadas').pipe();
    }

    getInstalacionesAutorizadasByProvincia(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/instalacionesAutorizadasByProvincia/' + id).pipe();
    }

    getAllPaisesTcUsaCodigoPostal(): Observable<TcPaisUsaCodigoPostal[]> {
        return this.http.get<TcPaisUsaCodigoPostal[]>(this.baseUrl + 'api/core/global/paises/paisusacodigopostal').pipe();
    }

    getAllPaisesTcUsaCodigoPostalExpor(): Observable<TcPaisUsaCodigoPostal[]> {
        return this.http.get<TcPaisUsaCodigoPostal[]>(this.baseUrl + 'api/core/global/paisesExpor/paisusacodigopostal').pipe();
    }

    getAllPaisesUeTcUsaCodigoPostal(): Observable<TcPaisUsaCodigoPostal[]> {
        return this.http.get<TcPaisUsaCodigoPostal[]>(this.baseUrl + 'api/core/global/paises/paisueusacodigopostal').pipe();
    }

    getAllPaisesNoUeTcUsaCodigoPostal(): Observable<TcPaisUsaCodigoPostal[]> {
        return this.http.get<TcPaisUsaCodigoPostal[]>(this.baseUrl + 'api/core/global/paises/paisnoueusacodigopostal').pipe();
    }

    getAllPaisesNoUeConSpainTcUsaCodigoPostal(): Observable<TcPaisUsaCodigoPostal[]> {
        return this.http.get<TcPaisUsaCodigoPostal[]>(this.baseUrl + 'api/core/global/paises/paisnoueconspainusacodigopostal').pipe();
    }

    getAllPifs(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccion').pipe();
    }

    getPuntoInspeccionByPais(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccionPais/' + id).pipe();
    }
    getPuntoInspeccionByPaisReasignable(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccionPaisReasignable/' + id).pipe();
    }

    getPuntoControlByPais(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntoscontrolPais/' + id).pipe();
    }

    getPuntosInspeccionByZona(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccionZona/' + id).pipe();
    }

    getPuntoInspeccionNuevaSolicitudExportacion(params: HttpParams): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/puntosinspeccionnuevasolicitudexportacion/', { params: params }).pipe();
    }

    getTipoMedioTransporteById(id: number): Observable<Tc> {
        return this.http.get<Tc>(this.baseUrl + 'api/core/global/tiposmediotransportebyid/' + id).pipe();
    }

    getTipoMedioTransporte(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposmediotransporte').pipe();
    }

    getAllSeccionSeguimiento(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/SeccionSeguimiento').pipe();
    }

    getAllMotivoSeguimiento(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/MotivoSeguimiento').pipe();
    }

    getTipoMedioTransporteSinFerrocarril(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposmediotransportesinferrocarril').pipe();
    }

    getTipoPuntoInspeccion(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipospuntoinspeccion').pipe();
    }

    getEstadoSolicitud(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadossolicitud').pipe();
    }

    getTipoDocumento(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipodocumento').pipe();
    }

    getEstadoSolicitudExpor(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadossolicitudEx').pipe();
    }

    getEstadoPV(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadosPv').pipe();
    }

    getEstadoSolicitudCpe(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadosSolicitudCpe').pipe();
    }

    getEstadoSolicitudAtestFito(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadossolicitudAtestFito').pipe();
    }

    getEstadoCertificadoFitoEx(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/estadoscertificadofitoEx').pipe();
    }

    getEstadoChedPP(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/EstadosChedPP').pipe();
    }

    getZonas(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/zonas').pipe();
    }

    getProvincias(): Observable<Tc[]> {
        if (this.provincias?.length > 0) {
            return of(this.provincias);
        }
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/provincias').pipe(
            tap(res => {
                this.provincias = res;
            }),
        );
    }

    getProvinciasPorIdZona(idZona: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/provincias/' + idZona).pipe();
    }

    getProvinciasByComunidad(idCA: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/provinciasByComunidad/' + idCA).pipe();
    }

    getMunicipios(idProvincia: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/municipios/' + idProvincia).pipe();
    }

    getMunicipiosComplete(idProvincia: number): Observable<MunicipioViewModel[]> {
        return this.http.get<MunicipioViewModel[]>(this.baseUrl + 'api/core/global/municipioscomplete/' + idProvincia).pipe();
    }

    getTipoModulos(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipomodulos').pipe();
    }

    getTipoModulosImporComunes(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipomodulosimporcomunes').pipe();
    }

    getTipoSolicitud(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposolicitud').pipe();
    }

    getTipoSolicitudActivos(): Observable<TcExpanded[]> {
        return this.http.get<TcExpanded[]>(this.baseUrl + 'api/core/global/tiposolicitudActivos').pipe();
    }

    getTipoSolicitudExpor(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposolicitudEx').pipe();
    }
    getTipoSolicitudExporSl(): Observable<TcExpanded[]> {
        return this.http.get<TcExpanded[]>(this.baseUrl + 'api/core/global/tiposolicitudExSl').pipe();
    }

    getTipoSolicitudExporActivos(): Observable<TcExpanded[]> {
        return this.http.get<TcExpanded[]>(this.baseUrl + 'api/core/global/tiposolicitudExActivos').pipe();
    }

    getSubTipoSolicitudExpor(): Observable<SubTipoSolicitudExViewModel[]> {
        return this.http.get<SubTipoSolicitudExViewModel[]>(this.baseUrl + 'api/core/global/SubTipoSolicitudEx').pipe();
    }

    getTipoSolicitudAtestFito(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposolicitudAtestFito').pipe();
    }

    getTipoSolicitudCam(): Observable<Tc[]> {
        if (this.tipoSolicitudCam?.length > 0) {
            return of(this.tipoSolicitudCam);
        }
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipoSolicitudCam').pipe(
            tap(res => {
                this.tipoSolicitudCam = res;
            }),
        );
    }

    getResultadoSolicitudAtestFito(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/resultadosolicitudAtestFito').pipe();
    }

    getSubTipoSolicitud(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/subtiposolicitud').pipe();
    }

    getIdioma(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/idioma').pipe();
    }

    getTipoTransbordo(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipoTransbordo').pipe();
    }

    getTipoTransbordoById(id: number): Observable<Tc> {
        return this.http.get<Tc>(this.baseUrl + 'api/core/global/tipoTransbordoById/' + id).pipe();
    }

    getTipoEnvio(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipoEnvio').pipe();
    }

    getTipoCantidad(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipoCantidad').pipe();
    }

    getAcciones(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/acciones').pipe();
    }

    getAccionesByModulo(idModulo: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/acciones/' + idModulo).pipe();
    }

    getTipoAsignacion(esInspector: boolean): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tipoasignacion/' + esInspector).pipe();
    }

    getTipoBultos(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/bultos').pipe();
    }

    getTipoEmbalaje(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/embalaje').pipe();
    }

    getUnidadMedidaPeso(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/unidadMedidaPeso').pipe();
    }

    getTipoOrganismoNocivo(): Observable<TwTcTipoOrganismoNocivoViewModel[]> {
        return this.http.get<TwTcTipoOrganismoNocivoViewModel[]>(this.baseUrl + 'api/core/global/tipoOrganismoNocivo').pipe();
    }

    getGrupos(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/grupos').pipe();
    }

    getFormas(): Observable<FormaViewModel[]> {
        return this.http.get<FormaViewModel[]>(this.baseUrl + 'api/core/global/formas').pipe();
    }

    getFormasByGrupo(idGrupo: number): Observable<FormaViewModel[]> {
        return this.http.get<FormaViewModel[]>(this.baseUrl + 'api/core/global/formas/' + idGrupo).pipe();
    }

    getSubFormasByForma(idForma: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/subformas/' + idForma).pipe();
    }

    getEnvioAduanas(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/envioaduanas').pipe();
    }

    getPuntoInspeccionByProvincia(idProvincia: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/PuntosInspeccionIdProvincia/' + idProvincia).pipe();
    }

    getPuntoInspeccionByProvinciaImporExpor(params: HttpParams): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/PuntosInspeccionIdProvinciaImporExpor/', { params: params }).pipe();
    }

    getAduanaByPuntoInspeccion(idPuntoInspeccion: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/aduanas/' + idPuntoInspeccion).pipe();
    }

    getUbicacionByPuntoInspeccion(params: HttpParams): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/getubicacionesbypuntoinspeccion/', { params: params }).pipe();
    }

    getAllUbicacionByPuntoInspeccion(idPuntoInspeccion: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/getallubicacionesbypuntoinspeccion/' + idPuntoInspeccion).pipe();
    }

    getIntervaloHorasByPuntoInspeccion(idPuntoInspeccion: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/intervalosHora/' + idPuntoInspeccion).pipe();
    }

    getPerfilesUsuario(): Observable<Tc[]> {
        if (this.perfilesUsuario?.length > 0) {
            return of(this.perfilesUsuario);
        }
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/perfilesusuario').pipe(
            tap(res => {
                this.perfilesUsuario = res;
            }),
        );
    }

    getPerfilesContenido(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/PerfilesContenido');
    }

    getPerfilesUsuarioCexveg(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/perfilesusuariocexveg').pipe();
    }

    getPerfilesUsuarioSolicitantes(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/perfilesusuariosolicitantes').pipe();
    }

    getPerfilesUsuarioExterno(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/perfilesusuarioexterno').pipe();
    }

    getComunidadesAutonomas(): Observable<Tc[]> {
        if (this.comunidadesAutonomas?.length > 0) {
            return of(this.comunidadesAutonomas);
        }
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/comunidadesautonomas').pipe(
            tap(res => {
                this.comunidadesAutonomas = res;
            }),
        );
    }

    getAllTiposVia(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposvia').pipe();
    }

    getTipoOperacionAduanas(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposoperacionaduanas').pipe();
    }

    getLaboratorioReferencia(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/laboratorioreferencia').pipe();
    }

    getValorSeguimientoLab(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/valorseguimientolab').pipe();
    }

    getCodigoEppoPagedByFilter(params: HttpParams): Observable<TwTcEppoItemResultsViewModel> {
        return this.http.get<TwTcEppoItemResultsViewModel>(this.baseUrl + 'api/core/global/twtceppo/pagedbyfilter/', { params: params }).pipe();
    }

    getAlcancesRechazo(idMedida: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/alcancesrechazo/' + idMedida).pipe();
    }

    getElementosRechazo(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/ElementosRechazo').pipe();
    }

    getMedidasRechazo(): Observable<MotivoMedidaViewModel[]> {
        return this.http.get<MotivoMedidaViewModel[]>(this.baseUrl + 'api/core/global/medidasrechazo').pipe();
    }

    getDetalleMotivosRechazoById(idMotivo: number): Observable<MotivoMedidaViewModel[]> {
        return this.http.get<MotivoMedidaViewModel[]>(this.baseUrl + 'api/core/global/detallemotivosrechazo/' + idMotivo).pipe();
    }

    getMotivosRechazo(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/motivosrechazo').pipe();
    }

    getGradoContaminacion(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/gradocontaminacion/').pipe();
    }

    getOrganismoNocivoNoReguladoUE(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/organismonocivonoreguladoUE/').pipe();
    }

    getOrganismoNocivoNoEspecie(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/organismonocivonoespecie/').pipe();
    }

    getCambioCodigoConfeccion(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/cambioscodigoconfeccion').pipe();
    }

    getTiposNacionalCanarias(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/tiposnacionalcanarias').pipe();
    }

    getCodigosTaricInformes(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/codigosTaricInformes').pipe();
    }

    //Especies.
    getWBotanicaExtendedPagedByFilter(params: HttpParams): Observable<WBotanicaExtendedItemResultsViewModel> {
        return this.http
            .get<WBotanicaExtendedItemResultsViewModel>(this.baseUrl + 'api/core/especies/wbotanicabusquedasolicitud/pagedbyfilter/', { params: params })
            .pipe();
    }

    //Organismos Nocivos.
    getWOrganismosNocivosExtendedPagedByFilter(params: HttpParams): Observable<WOrganismosNocivosExtendedItemResultsViewModel> {
        return this.http
            .get<WOrganismosNocivosExtendedItemResultsViewModel>(this.baseUrl + 'api/core/organismosnocivos/pagedbyfilter/', { params: params })
            .pipe();
    }

    getTiposInstalacion(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/TiposInstalacion').pipe();
    }

    getTiposInspeccionCam(): Observable<Tc[]> {
        if (this.tiposInspeccionCam?.length > 0) {
            return of(this.tiposInspeccionCam);
        }
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/TiposInspeccionCam').pipe(
            tap(res => {
                this.tiposInspeccionCam = res;
            }),
        );
    }

    getTiposSolicitudCopia(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/TipoSolicitudCopiaEx').pipe();
    }

    getModelosCf(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/modeloscf').pipe();
    }

    getTiposErrorProductos(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/core/global/TiposErrorProducto/').pipe();
    }

    getUnlocodeExtendedPagedByFilter(params: HttpParams): Observable<WUnlocodeItemResultsViewModel> {
        return this.http.get<WUnlocodeItemResultsViewModel>(this.baseUrl + 'api/exportacion/unlocodeex/PagedByFilter', { params: params }).pipe();
    }
}
